import React from "react";

interface ClearFiltersButtonProps {
  onClick: () => void;
  show?: boolean;
  label?: string;
}

const ClearFiltersButton: React.FC<ClearFiltersButtonProps> = ({
  onClick,
  show = true,
  label = "Clear all",
}) => {
  if (!show) {
    return null;
  }

  return (
    <button
      onClick={onClick}
      aria-label="Clear all filters"
      className="ml-2 rounded-md px-2 py-1 text-sm text-gray-500 hover:bg-gray-100 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-1"
    >
      {label}
    </button>
  );
};

export default ClearFiltersButton;
